import {useEffect, useState} from "react";
import {db} from "../db";
import md5 from "blueimp-md5";
import Logo from "../images/logo_light_grey.png";
import PromptSpin from "../images/prompts.lottie";
import { ReactComponent as CloseIcon } from "../images/icons/white-close.svg";
import Swal from "sweetalert2";

export default function PromptHistory(props) {
    const [historyPrompts, setHistoryPrompts] = useState([]);
    const [selectedPrompt, setSelectedPrompt] = useState(null);  
    const [loading, setLoading] = useState(false);  
    const [animations, setAnimations] = useState(false);
    const [emptyHistory, setEmptyHistory] = useState(true)
    
    const handlePromptClick = (index) => {
        setSelectedPrompt(historyPrompts[index]);
      };
    
      const handleCloseModal = () => {
        setSelectedPrompt(null);
      };

    const clearHistory = async() => {
        console.log("Clear History");
        await db.transaction('rw', db.history, async () => {
            await db.history.clear();
        })
        .then(() => {
            Swal.fire({
                title: 'History Cleared Succesfully',
                timer: 2000,
                showConfirmButton: false
            })
            props.closeEvent()
        })   
    }  

    let count = 0;
    const getPromptHistory = async () => {
        setLoading(true);
        await db.history.reverse().toArray((collection => {
            console.log(`Checking for history`);
            
            // const promptHistory = [];
            // collection.forEach(item => {
            //     const exists = promptHistory.findIndex((history) => {
            //         if (history.prompt) {
            //             if (history.prompt.prompt.prompt === item.prompt.prompt.prompt) {
            //                 return true;
            //             }
            //         }
            //         return false;
            //     }) !== -1;
            //     if (!exists) {
            //         console.log('history item does not exist');
            //         promptHistory.push(item);
            //     }
            // });
            setHistoryPrompts(collection);
            console.log(collection.length);
            
            if (collection.length !== 0) {
                setEmptyHistory(false)
            }
        }));
        setLoading(false);
    }

    // console.log(db.history.reverse().toArray());

    useEffect(() => {
        setEmptyHistory(true)
        db.settings.where("key").equals("enable_animations").first(setting => {
            setAnimations(setting.value)
        })
        getPromptHistory();
    }, []);

    return (     
    <>
        <div className={"fixed top-0 left-0 z-10 flex flex-col justify-center place-items-center h-screen w-screen bg-dark-blue/40 backdrop-blur"}>
            <div className={"w-full mx-auto max-w-screen-lg bg-gray-500/50 flex flex-row justify-between items-center"}>
                <h1 className={"text-2xl text-white px-4 font-bold drop-shadow"}>Prompt History</h1>
                <div className="flex flex-row">
                    <button className={`py-2 px-4 m-2 rounded bg-red-600 transition ${emptyHistory ? 'opacity-60' : null}`} onClick={clearHistory} disabled={emptyHistory}>Delete All</button>
                    <button className={"px-5 py-2 rounded bg-dark-blue text-white m-2 hover:text-yellow transition"} onClick={() => props.closeEvent()}>
                        <CloseIcon alt='Close Image' className='h-7'/>
                    </button>
                </div>
            </div>
            {/* <PromptHistory setPrompt={setWholePrompt} closeEvent={() => setOpenHistory(false)} setSeedWithPrompt={setSeedPrompt}/> */}
            {loading ? 
                <>
                {animations ?
                    <div className="w-2/3 mx-auto">
                        <lottie-player
                        autoplay
                        loop
                        mode="normal"
                        src={PromptSpin}
                        ></lottie-player>
                    </div>
                :
                    <img src={Logo} alt={"Promptus Logo"} className="w-2/3 mx-auto animate-pulse" />  
                }
            </>  
                : 
            <ul className={`w-full mb-2 max-w-screen-lg bg-white py-5 px-2 text-dark-blue h-full max-h-screen overflow-auto ${selectedPrompt ? "hidden" : null}`}>
                {historyPrompts.map((historyPrompt, index) =>
                    <div className="transition flex flex-row align-middle justify-between">
                        <li className={"p-2 cursor-pointer w-full flex flex-col justify-center hover:bg-dark-blue/20 border border-black"} key={`prompt_${historyPrompt.id}`} onClick={() => {
                            props.setPrompt(historyPrompt.prompt, true);
                            props.closeEvent();
                        } }>
                            <div className={"text-base"}>{historyPrompt.prompt}</div>
                            {/* <div className={"self-end"}>{(new Date(historyPrompt.timestamp)).toLocaleString('en-GB')}</div> */}
                        </li>
                        {historyPrompt.seeds && historyPrompt.seeds.length > 0 && (
                            <button className={"p-2 self-end text-sm align-middle bg-yellow text-center text-dark-blue shadow font-bold cursor-pointer border border-black"} onClick={() => handlePromptClick(index)}>With Seeds</button>
                        )}
                    </div>
                )}
            </ul>
            }
                {selectedPrompt ? 
                        <ul className={"w-full max-w-screen-lg bg-white p-5 text-dark-blue h-full max-h-screen overflow-auto z-50"}>
                            <div>
                                <h2 className="text-lg">{selectedPrompt.prompt}</h2>
                                <ul>
                                    {selectedPrompt.seeds && selectedPrompt.seeds.length > 0 ? (
                                        selectedPrompt.seeds.map((seed, seedIndex) => (
                                        <li className={"p-2 cursor-pointer rounded hover:bg-dark-blue/20 transition border-b-2"} key={seedIndex} onClick={() => {
                                            props.setSeedWithPrompt(selectedPrompt.prompt, seed)
                                            props.closeEvent();
                                        }}>{seed}</li>
                                        ))
                                    ) : (
                                        <li className={"p-2 text-gray-500 italic"}>No seeds available for this prompt</li>
                                    )}
                                </ul>
                                <button className={"rounded w-60 p-2 bg-yellow text-dark-blue font-semibold shadow mt-5"} onClick={handleCloseModal}>Close</button>
                            </div>
                        </ul>
                    :
                        null
                }
        </div>
    </>
    );
}
